import * as React from 'react'
import { SVGProps } from 'react'
const SvgConvert = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M22 32.3v5.4c0 4.5-1.8 6.3-6.3 6.3h-5.4C5.8 44 4 42.2 4 37.7v-5.4c0-4.5 1.8-6.3 6.3-6.3h5.4c4.5 0 6.3 1.8 6.3 6.3ZM35 22a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM29.559 43.999c-.54 0-1.04-.3-1.3-.76-.26-.48-.26-1.04.02-1.52l1.94-3.24c.42-.72 1.34-.94 2.06-.52.72.42.94 1.34.52 2.06l-.36.6c4.94-1.28 8.58-5.76 8.58-11.08 0-.82.68-1.5 1.5-1.5s1.48.68 1.48 1.52c0 7.96-6.48 14.44-14.44 14.44ZM5.5 19.94c-.82 0-1.5-.66-1.5-1.5C4 10.48 10.48 4 18.44 4c.56 0 1.04.3 1.32.76.26.48.26 1.04-.02 1.52L17.8 9.5c-.44.72-1.36.96-2.06.52-.72-.42-.94-1.34-.52-2.06l.36-.6C10.66 8.64 7 13.12 7 18.44c0 .84-.68 1.5-1.5 1.5Z"
      fill="currentColor"
    />
  </svg>
)
export default SvgConvert
